<template>
  <v-row justify="center">
    <v-menu bottom min-width="200px" rounded offset-y>
      <template v-slot:activator="{ on }">
        <div>
          <v-btn icon x-large v-on="on" width="46" class="mr-3">
            <v-img :src="getClientImage(clients.rol)" transition="scale-transition" width="37" />
          </v-btn>
        </div>
      </template>
      <v-card>
        <v-list-item-content class="justify-center">
          <div class="mx-auto text-star">
            <v-btn depressed rounded text @click="insertRoute(clients.otherRoute)">
              <v-img :src="getOtherImage(clients.rol)" transition="scale-transition" width="40" />
              <span class="ml-2 text-capitalize">{{ clients.otherClient }}</span>
            </v-btn>
          </div>
        </v-list-item-content>
      </v-card>
    </v-menu>
  </v-row>
</template>

<script>
import avatarIntroPro from '@/assets/Profesional.svg';
import avatarIntroPat from '@/assets/Paciente.svg';

export default {
  name: 'VAvatarIntro',
  props: ['clients'],
  methods: {
    insertRoute(ruta) {
      this.$router.push(ruta);
    },
    getClientImage(rol) {
      return rol === 'pro' ? avatarIntroPro : avatarIntroPat;
    },
    getOtherImage(rol) {
      return rol === 'pat' ? avatarIntroPro : avatarIntroPat;
    },
  },
};
</script>